import { useEffect, useState } from 'react';

export function useTypewriter (
  text: string,
  isTyping: boolean,
  onComplete?: () => void // ✨ New optional callback
): string {
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    if (!isTyping || (text === '')) {
      setDisplayText(text.replace(/\\n/g, '<br>'));
      return;
    }

    const formattedText = text.replace(/\\n/g, '<br>');
    let index = 0;
    const speed = 10;

    setDisplayText(''); // Start from empty text

    const typingInterval = setInterval(() => {
      if (index < formattedText.length) {
        setDisplayText((_) => {

          return formattedText.substring(0, index + 1);
        });
        index++;
      } else {
        clearInterval(typingInterval);

        if (onComplete != null) {
          onComplete();
        }
      }
    }, speed);

    return () => {
      clearInterval(typingInterval);
    };

  }, [text, isTyping, onComplete]);

  return displayText;
}